import axios from "axios";
import { IPointCloudLoader, IPointCloudLoadParams, IPointCloudTileGeometry } from "./interface";


export class BINLoader implements IPointCloudLoader{
    public async load(params: IPointCloudLoadParams, abortController: AbortController): Promise<IPointCloudTileGeometry> {
      const allRequests: { url: string; config: any }[] = [];
      // for (const url of params.urls) {
        allRequests.push(
          {
            url: params.url + "/points.bin",
            config: {
              //   withCredentials: true,
              responseType: "arraybuffer",
              signal: abortController.signal,
            },
          },
          {
            url: params.url + "/colors.bin",
            config: {
              //   withCredentials: true,
              responseType: "arraybuffer",
              signal: abortController.signal,
            },
          }
        );
      // }
      //will fail if one fails
      const response = await Promise.all(
        allRequests.map((r) => axios.get(r.url, r.config))
      );
      // const result: IPointCloudTileGeometry[] = [];
      // for (let i = 0; i < response.length; i += 2) {
      //   result.push({
      //     vertices: new Float32Array(response[i].data),
      //     color: new Float32Array(response[i + 1].data),
      //   });
      // }
      return {
        vertices: new Float32Array(response[0].data),
        color: new Float32Array(response[1].data),
      };
    }
      
      
      
    //   const geometries = await this.loadPointCloudBin(params.urls, abortController);
    //     for (let i = 0; i < geometries.length; ++i) {
    //         const pointCloud = new PointCloud(
    //           this._settings,
    //           undefined,
    //           tiles.fetch[i]
    //         ); //factory needed
    //         pointCloud.setGeometry(data[i].points, data[i].color);
    //         for (const volMeasurement of volMeasurements) {
    //           const m = volMeasurement as IVolumeCalculationMeasurement;

    //           pointCloud.applyHeightBasedColor(
    //             m.pointColorRangeInfo,
    //             m.polygonMesh,
    //             new Box2().setFromPoints(
    //               m.polygonMesh.vertices as unknown as Vector2[]
    //             ),
    //             offsetMatrix
    //           );
    //         }

    //         const mesh = pointCloud.getMesh();
    //         // mesh.applyMatrix4(this._offsetMatrix);
    //         const debug = pointCloud.getDebug();

    //         this._group.add(mesh);
    //         this._debugGroup.add(debug);
    //         tiles.fetch[i].pointcloud = pointCloud;
    //         if (this.getRenderedTiles().length === 1) {
    //           this.getLoadedTiles();
    //         }
    //         tiles.fetch[i].loadingStatus = "loaded";
    //           this._viewer.updateRenderer();
    //       }
        
    // }
}